var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import { defineMessages, FormattedHTMLMessage, FormattedMessage, injectIntl } from "react-intl";
import classNames from "classnames";
import usdtIcon from "../../assets/img/payment/usdt.svg";
import UzcardForm from "./forms/UzcardForm";
import UsdtFormWithdraw from "./forms/UsdtFormWithdraw";
import { EXPAY_PROVIDER, USDT_PROVIDER } from "../../constants/Withdraw";
var UZS_WITHDRAW_PROVIDERS = [
    {
        label: "bank_card",
        messageId: "recharge.expay.bank_card"
    },
    {
        label: "USDT",
        img: usdtIcon,
        messageId: "USDT"
    }
];
var messages = defineMessages({
    title: {
        id: "withdraw.select_payment_method",
        defaultMessage: "Выберите способ снятия"
    },
    through: {
        id: "withdraw.through",
        defaultMessage: "Снятие через"
    }
});
var internalErrorMsg = {
    id: "withdraw.withdraw_form_internal_error",
    defaultMessage: "Внутренняя ошибка системы. Попробуйте позже"
};
var errors = defineMessages({
    "-1": {
        id: "withdraw.withdraw_form_user_not_have_permission",
        defaultMessage: "Нет прав на снятие средств"
    },
    "-4": {
        id: "withdraw.withdraw_form_not_enough_amount",
        defaultMessage: "Недостаточно средств"
    },
    "-7": {
        id: "withdraw.withdraw_form_wrong_password",
        defaultMessage: "Неверный пароль"
    },
    "-110": {
        id: "withdraw.minAmount",
        defaultMessage: "Данная сумма меньше минимальной доступной к выводу"
    },
    "-100": internalErrorMsg,
    "-1000": internalErrorMsg,
    "-10000": internalErrorMsg
});
var Uzcard = /** @class */ (function (_super) {
    __extends(Uzcard, _super);
    function Uzcard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedPayment: null
        };
        _this.onPaymentSelect = function (providerLabel) {
            if (_this.state.selectedPayment !== providerLabel) {
                _this.props.clearWithdrawErrorAction();
            }
            _this.setState({ selectedPayment: providerLabel });
        };
        _this.handleBack = function () {
            _this.props.clearWithdrawErrorAction();
            _this.setState({ selectedPayment: null });
        };
        _this.handleBankCardSubmit = function (values) {
            var user = _this.props.user;
            var data = {
                Type: "Expay",
                Withdrawal: __assign(__assign({}, values), { GamblerId: user.gamblerId })
            };
            _this.props.createWithdrawAction(data, EXPAY_PROVIDER);
        };
        _this.handleUsdtSubmit = function (values) {
            var user = _this.props.user;
            var data = {
                Type: "Crypto",
                Withdrawal: __assign(__assign({}, values), { GamblerId: user.gamblerId })
            };
            _this.props.createWithdrawAction(data, USDT_PROVIDER);
        };
        _this.getProviderTitle = function (provider) {
            if (provider.messageId === "USDT") {
                return "USDT";
            }
            return _this.props.intl.formatMessage({ id: provider.messageId });
        };
        return _this;
    }
    Uzcard.prototype.renderError = function () {
        var error = this.props.withdraw.get("createWithdrawError");
        if (!error || error === -400) {
            return null;
        }
        var msg = errors[error] || errors["-100"];
        return (_jsx("p", __assign({ className: "important important--withdraw rec", style: { margin: "15px 15px 0", paddingTop: "2px" } }, { children: _jsx(FormattedHTMLMessage, __assign({}, msg)) })));
    };
    Uzcard.prototype.render = function () {
        var _this = this;
        var selectedPayment = this.state.selectedPayment;
        var _a = this.props, rates = _a.rates, user = _a.user, fetching = _a.fetching, intl = _a.intl;
        var listClass = "providers__list" + (selectedPayment ? " providers__list-selected" : "");
        var selectedProvider = UZS_WITHDRAW_PROVIDERS.find(function (p) { return p.label === selectedPayment; });
        var formProps = {
            rates: rates,
            user: user,
            fetching: fetching
        };
        var usdtProps = {
            submitAction: this.handleUsdtSubmit,
            languageId: this.props.languageId,
            fetching: fetching,
            user: user,
            withdraw: this.props.withdraw
        };
        return (_jsxs("div", __assign({ className: "new-withdraw" }, { children: [_jsxs("div", __assign({ className: classNames("new-withdraw__head withdraw__head", {
                        selected: selectedPayment
                    }) }, { children: [selectedPayment ? (_jsx("a", { className: "new-join__back", onClick: this.handleBack })) : (_jsx(Link, { className: "new-join__back", to: "/" })), _jsx("span", { children: selectedProvider ? ("".concat(intl.formatMessage(messages.through), " ").concat(this.getProviderTitle(selectedProvider))) : (_jsx(FormattedMessage, __assign({}, messages.title))) })] })), _jsx("div", __assign({ className: listClass }, { children: UZS_WITHDRAW_PROVIDERS.map(function (provider) {
                        var active = selectedPayment === provider.label;
                        return (_jsx("div", __assign({ onClick: function () { return _this.onPaymentSelect(provider.label); }, className: "providers__list__item-wrapper" }, { children: _jsx("div", __assign({ className: classNames("providers__list__item", { active: active }) }, { children: provider.label === "bank_card" ? (_jsx("span", __assign({ className: "providers__list__item-label" }, { children: _jsx(FormattedMessage, { id: provider.messageId }) }))) : (_jsx("img", { height: 40, width: "auto", alt: provider.label, src: provider.img })) })) }), provider.label));
                    }) })), this.renderError(), selectedPayment === "bank_card" && (_jsx("div", __assign({ className: "uzcard_reacherge" }, { children: _jsx(UzcardForm, __assign({}, formProps, { submitAction: this.handleBankCardSubmit, errorCode: this.props.withdraw.get("createWithdrawError") })) }))), selectedPayment === "USDT" && (_jsx("div", __assign({ className: "new-withdraw__wrapper" }, { children: _jsx("div", __assign({ className: "toggle_content" }, { children: _jsx("div", __assign({ className: "body" }, { children: _jsx(UsdtFormWithdraw, __assign({}, usdtProps)) })) })) })))] })));
    };
    return Uzcard;
}(React.Component));
export default injectIntl(Uzcard);



// WEBPACK FOOTER //
// ./src/components/withdraw/Uzcard.jsx